import React, { useState, useEffect } from 'react';
import {
  Box,
  MenuItem,
  TextField,
  Grid,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const DateFilterForm = ({ onApply }) => {
  const [filterType, setFilterType] = useState('monthly');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  useEffect(() => {
    if (filterType === 'custom') {
      if (fromDate && toDate) {
        onApply({ filterType, fromDate, toDate });
      }
    } else {
      onApply({ filterType });
    }
  }, [filterType, fromDate, toDate]);

  return (
    <Box
      sx={{
        width: "100%",
        mx: 'auto',
        mt: 3,
        px: 2, // padding vetëm majtas e djathtas
        bgcolor: 'white',
        // boxShadow: 2,
        // borderRadius: 2,
      }}

    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            select
            label="Lloji i Filtrit"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <MenuItem value="daily">Ditore</MenuItem>
            <MenuItem value="weekly">Java Aktuale</MenuItem>
            <MenuItem value="monthly">Muaji Aktual</MenuItem>
            <MenuItem value="yearly">Viti Aktual</MenuItem>
            <MenuItem value="custom">Sipas Datave</MenuItem>
          </TextField>
        </Grid>

        {filterType === 'custom' && (
          <>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="date"
                label="Nga Data"
                InputLabelProps={{ shrink: true }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="date"
                label="Deri më"
                InputLabelProps={{ shrink: true }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Grid>
          </>
        )}
      </Grid>
      <div style={{ display: 'flex', alignItems: 'center', color: '#284945', padding: '5px 0' }}>
        <InfoOutlinedIcon sx={{ marginRight: 1 }} />
        <p style={{ margin: 0 }}>
          Automatikisht janë të shfaqura transaksionet për javën aktuale. Përdorni filtrin për të ndryshuar periudhën e shfaqjes sipas nevojës.
        </p>
      </div>
    </Box>
  );
};

export default DateFilterForm;
